export default {
  email: '',
  password: ''
};
